import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const vuetify = new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#00843D',
                secondary: '#FFCD00',
                accent: '#FFCD00',
                error: '#b71c1c',
            },
        },
    },
})

export default vuetify
